import { Box } from "@mui/material";
import React from "react";
import ReactApexChart from "react-apexcharts";

export const PieChart = () => {
  const donutData = {
    series: [40, 60],

    options: {
      labels: ["Scholar Share", "Guild Share"],
      chart: {
        width: 380,
        height: "350px",
        type: "donut",
      },
      dataLabels: {
        enabled: false,
      },
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 200,
            },
            legend: {
              show: false,
            },
          },
        },
      ],
      colors: ["#6A27EA", "#16F095"],
      fill: {
        colors: ["#6A27EA", "#16F095"],
      },
      legend: {
        position: "bottom",
        offsetX: 0,
        height: 20,
        formatter: function (seriesName, opts) {
          return [opts.w.globals.series[opts.seriesIndex], "%", seriesName];
        },
      },
    },
  };

  return (
    <Box
      width="100%"
      sx={{
        marginTop: "30px",
        "& .apexcharts-toolbar": {
          display: "none",
        },
      }}
    >
      <ReactApexChart
        options={donutData.options}
        series={donutData.series}
        type="donut"
        height="500"
      />
    </Box>
  );
};
